module.exports = __webpack_public_path__ + "static/media/shapefile.616216a3.png";